import React from 'react';
import { Dialog } from '@producer/ui-kit';

import { ShareLinkPasswordSection } from './share-link-password-section';

import type { ShareLink } from '../../../app/entities/share-link';

import styles from './share-link-password-dialog.module.scss';

type ShareLinkPasswordDialogProps = {
  link: ShareLink;
  isPasswordRequired: boolean;
  isProLocked: boolean;
  onClose: () => void;
};

/**
 * The edit path for the password of an existing link: the share modal always creates a new one.
 */
export const ShareLinkPasswordDialog: React.FC<ShareLinkPasswordDialogProps> = ({
  link,
  isPasswordRequired,
  isProLocked,
  onClose,
}) => (
  <Dialog title={link.name || 'Share link'} onClose={onClose}>
    <div className={styles['container']}>
      <ShareLinkPasswordSection
        link={link}
        isPasswordRequired={isPasswordRequired}
        isProLocked={isProLocked}
      />
    </div>
  </Dialog>
);
